import React from "react";
import "./effectoscroll.css";

import Reloj from "../TimeAnimation/TimeAnimation";
import Aumento from "../TimeAnimation/aumento";
import Analytics from "../TimeAnimation/analytics";
import Lider from "../TimeAnimation/lider";

const Card = ({ title, description, imageUrl, customClass }) => (
  <div className="card">
    <div className="card__inner">
      <div className={`card__image-container ${customClass}`}>
        {typeof imageUrl === "string" ? (
          <img className="card__image" src={imageUrl} alt="" />
        ) : (
          imageUrl
        )}
      </div>
      <div className="card__content">
        <h1 className="card__title">{title}</h1>
        <p className="card__description">{description}</p>
      </div>
    </div>
  </div>
);

const Effetoscroll = () => {
  const cardsData = [
    {
      title: "Optimización de procesos institucionales",
      description: "Automatizamos tareas administrativas y académicas para que tu institución gane tiempo y eficiencia.",
      imageUrl: <Reloj />,
      customClass: "card__image-container--custom",
    },
    {
      title: "Comunidad educativa más conectada",
      description:
        "Centralizamos comunicación, seguimiento pedagógico y gestión en un único entorno digital.",
      imageUrl: <Aumento />,
      customClass: "card__image-container--custom",
    },
    {
      title: "Gestión basada en datos reales",
      description:
        "Reportes inteligentes y métricas claras para tomar decisiones estratégicas con confianza.",
      imageUrl: <Analytics />,
      customClass: "card__image-container--custom",
    },
    {
      title: "Posicionamiento e innovación institucional",
      description: "Impulsamos a tu institución como referente tecnológico dentro del ecosistema educativo.",
      imageUrl: <Lider />,
      customClass: "card__image-container--custom",
    },
  ];

  return (
    <section className="effect-scroll-wrapper">
      <div
        className="cards"
        style={{ "--cards-count": cardsData.length }}
      >
        {cardsData.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>

      <div className="space space--small" />
      <div className="space" />
    </section>
  );
};

export default Effetoscroll;